window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');


window.document.addEventListener("DOMContentLoaded", function () {
    const lightbox = document.getElementById("publicationLightbox");
    const lightboxImage = document.getElementById("publicationLightboxImage");
    const lightboxTitle = document.getElementById("publicationLightboxTitle");
    const lightboxCaption = document.getElementById("publicationLightboxCaption");
    let lightboxOpener = null;

    function closePublicationLightbox() {
        if (!lightbox) return;

        lightbox.hidden = true;
        document.body.classList.remove("publication-lightbox-open");
        lightboxImage.removeAttribute("src");
        lightboxOpener?.focus();
        lightboxOpener = null;
    }

    if (lightbox && lightboxImage && lightboxTitle && lightboxCaption) {
        document.querySelectorAll(".publication-lightbox-trigger").forEach((trigger) => {
            trigger.addEventListener("click", () => {
                lightboxOpener = trigger;
                lightboxImage.src = trigger.dataset.lightboxSrc;
                lightboxImage.alt = trigger.dataset.lightboxAlt || "";
                lightboxTitle.textContent = trigger.dataset.lightboxTitle || "Figure";
                lightboxCaption.textContent = trigger.dataset.lightboxCaption || "";
                lightbox.hidden = false;
                document.body.classList.add("publication-lightbox-open");
                lightbox.querySelector(".publication-lightbox-close")?.focus();
            });
        });

        lightbox.querySelectorAll("[data-lightbox-close]").forEach((closer) => {
            closer.addEventListener("click", closePublicationLightbox);
        });

        document.addEventListener("keydown", (event) => {
            if (event.key === "Escape" && !lightbox.hidden) {
                closePublicationLightbox();
            }
        });
    }

    document.querySelectorAll("[data-copy-target]").forEach((button) => {
        button.addEventListener("click", () => {
            const target = document.getElementById(button.dataset.copyTarget);
            if (!target) return;
            const text = target.textContent || "";
            navigator.clipboard.writeText(text).then(() => {
                const original = button.textContent;
                button.textContent = "Copied";
                window.setTimeout(() => {
                    button.textContent = original;
                }, 1800);
            }).catch(() => {
                const range = document.createRange();
                range.selectNodeContents(target);
                const selection = window.getSelection();
                selection?.removeAllRanges();
                selection?.addRange(range);
            });
        });
    });

    document.addEventListener('activate.bs.scrollspy', function (event) {
    const activeLink = document.querySelector('#tocSidebar .nav-link.active');

    if (!activeLink) return;

    // Expand all ancestor collapses
    let parent = activeLink.closest('.collapse');
    while (parent) {
      const p = parent?.parentElement?.querySelector('.nav-link');
      if (p){
        p.classList.add('active');
      }
      const bsCollapse = bootstrap.Collapse.getOrCreateInstance(parent);
      bsCollapse.show();
      parent = parent.parentElement.closest('.collapse');
    }

    // Optionally collapse siblings
    document.querySelectorAll('#tocSidebar .collapse.show').forEach(el => {
      if (!el.contains(activeLink)) {
        // el.classList.remove('active');
        const p = parent?.parentElement?.querySelector('.nav-link');
        if (p){
          p.classList.remove('active');
        }
        bootstrap.Collapse.getInstance(el)?.hide();
      }
    });
  });
});
